import { AssignmentTurnedInOutlined, EditOutlined } from "@mui/icons-material";
import { IconButton, Stack, SxProps, Typography } from "@mui/material";
import { useState } from "react";
import { ContextLabel, EditContextModal } from "src/components";
import { IssueDto, IssueSummaryDto, useEditIssueContext } from "src/http";

interface Props {
  issue: IssueDto | IssueSummaryDto;
  isEditable: boolean;
  openDrawerOnClick?: boolean;
  sx?: SxProps;
}

const IssueContextProperty = (props: Props) => {
  const { context } = props.issue;
  const [isEditModalVisible, setIsEditModalVisible] = useState<boolean>(false);
  const { mutate: editIssueContext } = useEditIssueContext();

  async function handleContextChanged(contextActionItemGuid: string | null) {
    editIssueContext({
      issueGuid: props.issue.guid,
      contextActionItemGuid: contextActionItemGuid,
      assignTeamSlug: props.issue.assignedTeam?.slug,
      createdByUserId: props.issue.createdByUser.userId,
    });
    setIsEditModalVisible(false);
  }

  return (
    <>
      <Stack direction="row" spacing={0.25} sx={{ alignItems: "center", width: "100%", ...props.sx }}>
        <AssignmentTurnedInOutlined />
        <Stack direction="row" sx={{ flex: 1, overflow: "hidden" }}>
          {context == null ? (
            <Typography variant="placeholder" noWrap sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
              Connect to Context
            </Typography>
          ) : (
            <ContextLabel context={context} hideTeamName openDrawerOnClick={props.openDrawerOnClick} />
          )}
        </Stack>

        {props.isEditable && (
          <IconButton size="small" sx={{ color: "rgba(0, 0, 0, 0.3)" }} onClick={() => setIsEditModalVisible(true)}>
            <EditOutlined />
          </IconButton>
        )}
      </Stack>

      {props.isEditable && (
        <EditContextModal
          open={isEditModalVisible}
          context={props.issue.context}
          onUpdateClicked={handleContextChanged}
          onCancelled={() => setIsEditModalVisible(false)}
        />
      )}
    </>
  );
};

export { IssueContextProperty };
